import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { TenantAPIService } from 'src/app/extensions/services/api/tenant-api.service';

@Injectable({
  providedIn: 'root',
})
export class WorkspaceInterceptor implements HttpInterceptor {
  constructor(private _tenantAPIService: TenantAPIService) {}

  workspaceFreeApiRequestRoutes: string[] = ['getTenantId', 'userData', 'getApplicationId', 'getSidebarMenuItems'];

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.workspaceFreeApiRequestRoutes.some(apiRoute => req.url.includes(apiRoute))) return next.handle(req);

    const tenantId = localStorage.getItem('tenantId');
    if (tenantId != null) {
      return this.processRequestWithWorkspace(tenantId, req, next);
    }

    return this._tenantAPIService.getTenantId().pipe(
      mergeMap(tenantId => {
        console.log(tenantId);
        return this.processRequestWithWorkspace(tenantId, req, next);
      })
    );
  }

  private processRequestWithWorkspace(tenantId: string, req: HttpRequest<any>, next: HttpHandler) {
    localStorage.setItem('tenantId', tenantId);
    req = req.clone({ headers: req.headers.append('workspace', tenantId) });

    const subTenant = localStorage.getItem('subTenant');
    const subTenantId = subTenant && JSON.parse(subTenant)?.id;
    if (subTenantId) {
      req = req.clone({ headers: req.headers.append('subtenant', subTenantId) });
    }

    return next.handle(req);
  }

  private isSameOriginUrl(req: any) {
    // It's an absolute url with the same origin.
    if (req.url.startsWith(`${window.location.origin}/`)) {
      return true;
    }

    // It's a protocol relative url with the same origin.
    // For example: //www.example.com/api/Products
    if (req.url.startsWith(`//${window.location.host}/`)) {
      return true;
    }

    // It's a relative url like /api/Products
    if (/^\/[^\/].*/.test(req.url)) {
      return true;
    }

    // It's an absolute or protocol relative url that
    // doesn't have the same origin.
    return false;
  }
}
